
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/topBar/dropPanel/promotionalPanel/linksList.scss.css.virtualfile';
        module.exports = {"linksListItem":"_linksListItem_1sezl_7","text":"_text_1sezl_13","symbolContainer":"_symbolContainer_1sezl_17"};